export default function createBreadcrumbs(path) {
  const pathArray = path.split('/').filter(Boolean);
  const breadcrumbs = pathArray.map((part, index) => {
    const link = `/${pathArray.slice(0, index + 1).join('/')}`;
    return { label: part, link };
  });
  return breadcrumbs;
}
